<template>
	<div class="objectdata-view container-fluid">
		<div class="row">
			<div class="col-8 main">

				<div v-for="item in objectdataTextItems"
				     class="row">
					<erco-text-input class="col-12"
									 :data-infotextkey="`objectdata.${item.labelKey}`"
					                 :label="item.label"
					                 :text="item.value"
					                 inputType="input"
					                 :keepUnfocused="true"
									 :forcePointerCursor="true"
									 :forceFocusOutline="isSidebarFocused(item.labelKey)"
									 :error="item.mandatory === 'true' && item.value === ''"
									 :tooltip="tooltipFor(item)"
									 :charlength="item.charlength"
									 :showMandatory="item.mandatory === 'true'"
					                 @click="openSidebarFor(item)">
					</erco-text-input>
				</div>

			</div>
			<div class="col-4 aside"></div>
		</div>
	</div>
</template>

<script>
	import Const from '@/constants';
	import InfoText from '@/helper/infoTextHelper';

	import ErcoTextInput from '@/components/molecules/ErcoTextInput';

	export default {
		name: 'ErcoObjectViewObjectDataOrganism',

		data() {
			return {
			};
		},

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		computed: {
			objectdataTextItems() {
				return this.$store.getters.mappedObjectDataItems.textItems;
			},
			objectdataTextTranslations() {
				return this.$store.getters.mappedObjectDataItems.textItemsTranslations;
			},
			mandatoryMissing() {
				return this.$store.getters.getMissingMandatoryFields;
			},
		},

		methods: {
			openSidebarFor(item) {
				const tabs = Const.langs.map((lang) => {
					const text = (this.objectdataTextTranslations[lang.key] &&
					              this.objectdataTextTranslations[lang.key].items[item.key] &&
					              this.objectdataTextTranslations[lang.key].items[item.key].value) || '';
					return {
						key: item.key,
						tabKey: lang.key,
						label: lang.text,
						text,
						toBeFetched: this.objectdataTextTranslations[lang.key] === null,
					};
				});

				const outputData = {
					tabChangeAction: 'getObjectDataTranslation',
					selectedTabKey: this.$store.state.objectsetup.current.sprache,
					tabs,
					charlength: (item.charlength && parseInt(item.charlength, 10)) || false,
				};

				const titleAdditional = (outputData.charlength)
					? `(max. ${outputData.charlength} Zeichen)`
					: '';

				const sidebarData = {
					visible: true,
					key: item.labelKey,
					view: 'erco-sidebar-tabbed-text-input',
					fixed: true,
					outputData,
					context: {
						dispatchActionName: 'updateObjectDataItem',
						value: {
							siteId: this.$store.state.objectsites.objectdata.id,
						},
					},
					title: item.label,
					titleAdditional,
					info: InfoText.for(`objectdata.${item.labelKey}`),
				};

				this.$store.dispatch('updateSidebar', sidebarData);
			},

			tooltipFor(item) {
				const infoKey = `objectdata.${item.labelKey}`;
				const replacements = {};

				if (item.charlength) {
					replacements.maxChars = parseInt(item.charlength, 10);
				}
				return InfoText.for(infoKey, replacements) || { variant: '', title: '', text: '' };
			},

			isSidebarFocused(key) {
				const sidebarStore = this.$store.state.sidebar;
				return sidebarStore.visible && sidebarStore.key === key;
			},
		},

		components: {
			ErcoTextInput,
		},
	};
</script>

<style lang="scss">
	.objectdata-view {
		.main {
			background-color: rgba(242, 242, 242, 1);
			border-right: 1px solid transparent;
			padding: 1.5rem 4rem;
		}

		.aside {
			background-color: rgba(242, 242, 242, 1);
			padding: 1.5rem 1rem;
		}
	}
</style>



// WEBPACK FOOTER //
// ObjectData.vue?83d6380a